import './Profile.scss'
import { useState } from 'react'
import { classify } from '../../../helpers'

import Post from '../../../components/Post'
import Flex from '../../../components/utils/Flex'
import Container from '../../../components/utils/Container'
import TWButton from '../../../components/utils/TWButton/TWButton'
import TWUnfold from '../../../components/utils/TWUnfold/TWUnfold'

import PostImage from '../../../assets/images/post.png'
import ProfileThumbnail from '../../../assets/images/profile-thumb.png'
import ProfileCover from '../../../assets/images/profile-cover.png'

const Profile = () => {

	const [user] = useState({
		// subscription: '10$'
		subscription: ''
	})
	const [post] = useState({
		text: `Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
			nonumy eirmod tempor invidunt ut labore et dolore.. magna aliquyam
			erat, sed diam voluptua. At vero eos et accusam et justo duo dolores
			et ea rebum`,
		user: {
			fullName: 'RK Anik',
			username: '@rkanik',
			thumbnail: ProfileThumbnail,
		},
		images: [PostImage],
	})
	const [subscription, setSubscription] = useState({
		selected: 1,
		list: [
			{
				id: 1,
				title: '1 Month Subscription',
				price: '$5.98 (SALE)'
			},
			{
				id: 2,
				title: '3 Months Subscription',
				price: '$33.73 (25% OFF)'
			},
			{
				id: 3,
				title: '6 Months Subscription',
				price: '$62.96 (30% OFF)'
			},
			{
				id: 4,
				title: '12 Months Subscription',
				price: '$116.92 (35% OFF)'
			}
		]
	})

	const paidUser = user && user.subscription && user.subscription.trim() !== ''

	return (
		<div className="profile">
			<div className="relative">
				<div className="relative">
					<img
						src={ProfileCover}
						alt="Profile Cover"
						className="profile__cover-img w-full object-cover object-center"
					/>
				</div>
				<div className="profile__content absolute inset-0 flex flex-col justify-end items-center">
					<h2 className="profile__username text-primary font-bold flex items-center mb-2">
						Phoria Username
						<span className="material-icons ml-2 text-blue-300">
							verified_user
						</span>
					</h2>
					<div className="w-32 h-32 lg:w-44 lg:h-44 2xl:w-60 2xl:h-60 rounded-xl relative overflow-hidden -mb-16 lg:-mb-18 2xl:-mb-28">
						<img
							src={ProfileThumbnail}
							alt="Profile Thumbnail"
							className="w-full h-full object-cover object-center"
						/>
					</div>
				</div>
			</div>
			<Flex on="lg" className="bg-primary lg:pt-18 2xl:pt-0">
				<Flex
					items-center
					justify-center
					className="profile__stats mt-20 2xl:mt-0 py-3 lg:justify-end flex-1 space-x-4 text-cyan-accent font-bold"
				>
					<div className="bg-secondary2 py-2 px-4 2xl:py-3 2xl:px-8">Top 10%</div>
					<div className="py-2 px-4 2xl:py-3 2xl:px-8">234 Posts</div>
					<div className="py-2 px-4 2xl:py-3 2xl:px-8">2.3k Likes</div>
				</Flex>
				<div className="hidden lg:block lg:w-48 2xl:w-80"></div>
				<Flex
					items-center
					justify-center
					className="profile__tab lg:mt-20 2xl:mt-0 lg:justify-start space-x-4 flex-1 relative font-bold text-base lg:text-xl 2xl:text-3xl"
				>
					<Flex items-center className="h-full py-3 cursor-pointer px-2 active">Feed</Flex>
					<Flex items-center className="h-full py-3 cursor-pointer px-2">Videos</Flex>
					<Flex items-center className="h-full py-3 cursor-pointer px-2">Pictures</Flex>
					<Flex items-center lass="h-full py-3 store cursor-pointer px-2 store">Store</Flex>
				</Flex>
			</Flex>
			<div className="bg-secondary py-3 lg:py-10 text-center">
				<Container>
					<p className="text-sm lg:text-lg text-white mb-4 lg:mb-12">
						Last Online 2 Hours Ago
					</p>
					<TWUnfold className="unfold mx-auto text-left" content="bg-secondary2">
						Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
						nonumy eirmod tempor invidunt ut labore et dolore..magna
						aliquyam erat, sed diam voluptua.At vero eos et accusam et justo
						duo dolores et ea rebum<br /><br />
						Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
						nonumy eirmod tempor invidunt ut labore et dolore..magna
						aliquyam erat, sed diam voluptua.At vero eos et accusam et justo
						duo dolores et ea rebum<br /><br />
						Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
						nonumy eirmod tempor invidunt ut labore et dolore..magna
						aliquyam erat, sed diam voluptua.At vero eos et accusam et justo
						duo dolores et ea rebum
					</TWUnfold>

					{paidUser ? (
						<Container v2>
							<div className="my-8 flex lg:block justify-center space-x-4 lg:space-x-8">
								<TWButton size="lg" className="flex-1">Message</TWButton>
								<TWButton size="lg" className="flex-1">Send A Tip</TWButton>
							</div>
							<Post post={post} className="mb-7" />
						</Container>
					) : (
						<div className="text-left flex flex-col space-y-3 lg:space-y-6 mt-3 lg:mt-14">
							<div className="subscription w-full mx-auto font-bold text-white bg-primary p-4 rounded">
								Support Phoria Girl 9000
							</div>
							{subscription.list.map(sub => (
								<div
									key={sub.id}
									onClick={() => setSubscription(s => ({ ...s, selected: sub.id }))}
									className={classify("subscription w-full mx-auto text-white bg-secondary2 p-4 rounded flex justify-between cursor-pointer", {
										active: sub.id === subscription.selected
									})}
								>
									<h3 className="font-bold">
										{sub.title}
									</h3>
									<p className="font-light">
										{sub.price}
									</p>
								</div>
							))}
							<div className="subscription mx-auto text-center pt-2 lg:pt-4">
								<p className="text-white font-light">
									Normal Subscription is $14.99 per month
								</p>
							</div>
						</div>
					)}
				</Container>
			</div>
		</div>
	)
}

export default Profile